export default "__VITE_ASSET__5qDGPq5t__"